import { DateOnly } from '@nx-superprep/utils';

export interface CompletionState {
  activeDate?: DateOnly;
  selected: 'today' | 'overall';
  estimated?: number;
  completed: {
    today: number
    overall: number
  }
}

export const isSameCompletionState = (a: CompletionState|undefined, b: CompletionState|undefined): boolean => {
  return (a === b) || (
    !!a &&
    !!b &&
    a.selected === b.selected &&
    DateOnly.isEqual(a.activeDate, b.activeDate) &&
    (Number(a.estimated)||0) === (Number(b.estimated)||0) &&
    a.completed.today === b.completed.today &&
    a.completed.overall === b.completed.overall
  )
}
